module.exports = __webpack_public_path__ + "static/media/404.92c73b8b.png";